import { X } from "lucide-react";

export const MigrationBanner = ({ visible, dismiss }) => {
  if (!visible) return null;

  return (
    <div
      data-testid="migration-banner"
      className="fixed top-0 left-0 right-0 z-[60] flex h-9 items-center justify-center gap-3 border-b border-white/10 bg-[#12141D] px-4 text-xs text-[#FDFBF7]"
    >
      <span className="truncate">
        We&apos;re upgrading to a new site experience.{" "}
        <span className="text-[var(--aiv-accent)]">
          Some sections may still link to the classic site
        </span>{" "}
        during the transition.
      </span>
      <button
        type="button"
        onClick={dismiss}
        data-testid="migration-banner-dismiss"
        aria-label="Dismiss"
        className="shrink-0 text-[#A1A1AA] transition-colors hover:text-[#FDFBF7]"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
